import { colors } from "../colors/colors";

export const INTERVAL_DELAY_VALUE = 1000;
export const MILLIS_OF_SECONDS = 1000;
export const UNIT_EMERGENCY_BACKGROUND_COLOR = colors.unitEmergency;
export const UNIT_EMERGENCY_TEXT_COLOR = colors.unitEmergencyText;
